module.exports = __webpack_public_path__ + "static/media/group_copy_2.a57e15d1.jpg";